import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=5c2ff834&"
var script = {}
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports